export const APPSETTINGS = 'APPSETTINGS';